import { BrowserRouter } from 'react-router';

import { ToastRegion } from '@/shared/ui/index.js';

import { AppErrorBoundary } from './error-boundary.js';
import { AppProviders } from './providers.js';
import { AppRouter } from './router.js';

export function App() {
  return (
    <AppErrorBoundary>
      <AppProviders>
        <BrowserRouter>
          <AppRouter />
          <ToastRegion />
        </BrowserRouter>
      </AppProviders>
    </AppErrorBoundary>
  );
}
